import React from 'react';
import Axios from 'axios';
import commonService from 'core/common/service/commonService';
import {stringify} from 'core/common/utils/jsonUtils';
import {getParam} from "core/common/utils/utils";
import uiService from "core/common/service/uiService";
import {loc} from "core/common/config/locales";


let ssTenantId = sessionStorage.getItem('tenantId');
if (!isNaN(ssTenantId as any)) window.TENANT_ID = ssTenantId;
if (!window.TENANT_ID) {
  let parTenantId = getParam('t');
  if (parTenantId) parTenantId = parTenantId.trim();
  if(!isNaN(parTenantId as any)) window.TENANT_ID = parTenantId;
  if (window.TENANT_ID) {
    sessionStorage.setItem('tenantId', window.TENANT_ID);
  }
}

console.debug('axios init, tenant = ' + window.TENANT_ID);


const ZAUZOO_EXCEPTION_MARKER = 'ZAUZOO_EXCEPTION_MARKER';



const mdAxios = Axios.create({
  baseURL: '/api',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8',
    'Accept': 'application/json',
    'Accept-Language': loc.lang
  },
  transformRequest: [stringify]
});
mdAxios.interceptors.request.use(onRequestFullFilled, onRequestRejected);
mdAxios.interceptors.response.use(onResponseFullFilled, onResponseRejected);
export default mdAxios;


const uploadAxios = Axios.create({
  baseURL: '/api',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'multipart/form-data',
    'Accept-Language': loc.lang
  }
});
uploadAxios.interceptors.request.use(onRequestFullFilled, onRequestRejected);
uploadAxios.interceptors.response.use(onResponseFullFilled, onResponseRejected);
export {uploadAxios};




function onRequestFullFilled (config) {

  let tenantId = window.TENANT_ID;

  //console.log('intercepting request %O, tenantId = ' + tenantId, config);
  if (tenantId && config.headers['X-Tenant'] == null) {
    config.headers['X-Tenant'] = tenantId;
  }

  return config;
}

function onRequestRejected(error) {
  // Do something with request error
  return Promise.reject(error);
}



function onResponseFullFilled (response) {

  // pokud response.data jsou string a konci na specialni text, tak doslo na serveru k vyjimce pri json serializaci kdyz uz byla odpoved streamovana na klienta a tudiz nelze zmenit status 200
  // takze jsem pouze pridal ZAUZOO_EXCEPTION_MARKER a podle toho to poznam
  if (typeof response.data === 'string' && response.data.endsWith(ZAUZOO_EXCEPTION_MARKER)) {
    commonService.loading(false);
    if (commonService.notificationSystem) {
      doNotify(response);
    } else {
      window.location.replace("/login");
    }
  }
  return response;
}


function onResponseRejected (error) {
  // Do something with response error
  console.log('Error %O', error);

  commonService.loading(false);
  uiService.hideToolbarActionFlag();

  let errorResponse = error.response;

  if (errorResponse.status == 401) {
    let _r = commonService.router;
    if (_r) {
      commonService.redirectAfterLogin = _r.getCurrentPath();
      _r.transitionTo('loginPage');
    }
  } else if (errorResponse.status != 503) {
    if (commonService.notificationSystem) {
      if ((errorResponse.status !== 400 || !error.config.showPrettyError)) {
        doNotify(errorResponse);
      }
    } else {
      let _r = commonService.router;
      if (_r) {
        _r.transitionTo('home');
      } else {
        window.location.replace("/");
      }
    }
  }

  error.getMessages = () => {
    return (error.response && error.response.data) ? error.response.data.messages : undefined;
  };
  error.getMessagesString = () => {
    return (error.response && error.response.data && error.response.data.messages && error.response.data.messages.length) ? error.response.data.messages.map(m => m.message).join(", ") : undefined;
  };

  return Promise.reject(error);
}



function doNotify(error: any) {
  if (!commonService.notificationSystem) return;



  let content;
  if (error.data) {
    if (typeof error.data === 'string') {
      let pos = error.data.lastIndexOf(ZAUZOO_EXCEPTION_MARKER);
      let str = (pos === -1) ? error.data : error.data.substring(0, pos);
      content = ( <p>{str}</p> );
    } else if (error.data.severity) {
      content = (
        <ul>
          {error.data.messages.map((err: any, index: number) => (<li key={index}> { ( (err.propertyPath) ? (err.propertyPath + ' ') : '') + err.message + ( (err.rootBeanClass)? " ( on " + err.rootBeanClass + ')' : '' )} </li>) )}
        </ul>
      );
    } else {
      content = (
        <div>
          <p>{error.data.error}</p>
          <p>
            <pre>{error.data.exception} + ' - ' + {error.data.message}</pre>
          </p>
      </div> );
    }
  } else {
    content = ( <p>{error.statusText}</p> );
  }

  commonService.notifyError(null, "Server error " + error.status, content);


}




// WEBPACK FOOTER //
// ./src/core/common/config/axios-config.tsx